import type * as Types from '@aeppic/types'

export type * from '@aeppic/types'

export type DocumentIdentifier = Types.IdOrReference | Types.Document | { id: Types.DocumentId }

function isObject(object: unknown): object is Record<string, unknown> {
  return object != null && typeof object === 'object'
}

export function isDocument(identifier: unknown): identifier is Types.Document {
  if (!isObject(identifier)) {
    return false
  }

  const document = identifier as unknown as Types.Document
  return Boolean(document.id && document.data != null)
}

export function isReference(identifier: unknown): identifier is Types.Reference {
  if (!isObject(identifier)) {
    return false
  }

  return Boolean('id' in identifier && 'v' in identifier && identifier.id && identifier.v)
}

export function isStrictReference(identifier: unknown): identifier is Types.Reference {
  if (!isObject(identifier) || isDocument(identifier)) {
    return false
  }

  return isReference(identifier)
}

export function hasId(identifier: unknown): identifier is Types.Reference | Types.Document | { id: Types.DocumentId } {
  if (!isObject(identifier)) {
    return false
  }

  return Boolean(identifier.id)
}

export function readId(identifier: DocumentIdentifier): string {
  if (typeof identifier === 'string') {
    return identifier
  }

  return identifier.id
}
